export default __webpack_public_path__ + "static/media/add-circle-filled.ed93de4c.svg";